import { createRouter, createWebHistory } from 'vue-router';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
const routes = [
    {
        path: '/auth',
        name: 'Auth',
        component: () => import('@/views/auth/AuthView.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/RecordingsView.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    onAuthStateChanged(auth, (user) => {
        if (requiresAuth && !user) {
            next('/auth');
        }
        else if (!requiresAuth && user && to.path === '/auth') {
            next('/');
        }
        else {
            next();
        }
    });
});
export default router;
